import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { ReactComponent as Alert } from '../../assets/icons/alert.svg';
import {
  generateToken,
  tokenSentTimeAction,
  validateToken,
} from '../../store/auth/actions';
import { setCPF as setCPFRedux } from '../../store/auth/actions';

import { getContacts } from '../../store/contacts/actions';
import Loading from '../../components/Loading';
import { Button, ButtonContainer, Footer, Wrapper, Buttons } from './styles';
import { createSession, navigationUrl, updateSession } from '../../store/analytic/actions';
import Skeleton from 'react-loading-skeleton';
import moment from 'moment';
import BirthDateValidation from './Components/BirthDateValidation';
import TwoFactorValidation from './Components/TwoFactorValidation';
import ContactError from './Components/ContactError';
import ContactConfirmation from './Components/ContactConfirmation';
import NameValidation from './Components/NameValidation';
import MothersNameValidation from './Components/MothersNameValidation';

interface IParams {
  cpf: string;
}

const SelectContact: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { cpf }: IParams = useParams();
  const [contact, setContact] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [birthDate, setBirthDate] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [contactError, setContactError] = useState<boolean>(false);
  const [showTwofactor, setShowTwofactor] = useState<boolean>(false);
  const [info, setInfo] = useState<string>('');
  const [type, setType] = useState<string>('');
  const [contactConfirmation, setContactConfirmation] = useState(false);

  const {
    contactsLoading,
    contacts,
    contactsByCpf,
    useBirthDate,
    useTwoFactor,
    useName,
    useContact,
    selectedContact,
    status,
    usernameByCpf,
    useMothersName,
  } = useSelector((state: ApplicationState) => ({
    contacts: state.contacts.list || [],
    contactsByCpf: state.contactsByCpf,
    usernameByCpf: state.contactsByCpf?.user,
    selectedContact: state.contacts.selected,
    contactsLoading: state.contacts.contactsLoading,
    useTwoFactor: state.config.validacaoAcesso === '23' ? true : false,
    useBirthDate:
      state.config.validacaoAcesso === '24' &&
      state.contactsByCpf?.user?.[0]?.data
        ? true
        : false,
    useContact: state.config.validacaoAcesso === '25' ? true : false,
    useName:
      state.config.validacaoAcesso === '26' ||
      !state.contactsByCpf?.user?.[0]?.data
        ? true
        : false,
    useMothersName:
      state.config.validacaoAcesso === '27' &&
      state.contactsByCpf?.user?.[0]?.data
        ? true
        : false,
    status: state.auth.status,
  }));
  

  const handleBack = () => {
    dispatch(validateToken.failure(''));
    return cpf ? history.push('/') : history.goBack();
  };

  useEffect(() => {
    if (useContact || useTwoFactor) {
      if (!contactsLoading && contacts.length === 0) {
        setContactError(true);
      } else {
        setContactError(false);
      }
    }

    if (useName && !contactsByCpf.contactsLoading)
      if (
        contactsByCpf.error === 'Falha ao buscar contatos.' ||
        !usernameByCpf ||
        status === 'Usuário não encontrado'
      ) {
        setContactError(true);
      } else {
        setContactError(false);
      }

    if (useMothersName && !contactsByCpf.contactsLoading)
      if (
        contactsByCpf.error === 'Falha ao buscar contatos.' ||
        !usernameByCpf ||
        status === 'Usuário não encontrado'
      ) {
        setContactError(true);
      } else {
        setContactError(false);
      }

    if (useBirthDate && !contactsByCpf.contactsLoading) {
      if (
        contactsByCpf.error === 'Falha ao buscar contatos.' ||
        status === 'Usuário não encontrado'
      ) {
        setContactError(true);
      } else {
        setContactError(false);
      }
    }
  }, [
    contacts.length,
    contactsByCpf,
    useContact,
    useTwoFactor,
    contactsLoading,
    usernameByCpf,
    useName,
    useBirthDate,
    status,
    useMothersName,
  ]);

  useEffect(() => {
    if ((useTwoFactor || useContact) && !contactError && !contactConfirmation) {
      setShowTwofactor(true);
    }
    if (contactConfirmation) {
      setShowTwofactor(false);
    }
  }, [useTwoFactor, useContact, contactError, contactConfirmation]);

  useEffect(() => {
    if (selectedContact?.type === 'Email') {
      setType('string');
      setInfo(selectedContact?.email ?? '');
    } else {
      setType('number');
      setInfo(selectedContact?.telephone ?? '');
    }
  }, [selectedContact]);

  useEffect(() => {
    if (cpf) {
      dispatch(createSession.request('/'));
      dispatch(getContacts.request({ cpf }));
      dispatch(setCPFRedux(cpf));
    }
    dispatch(
      navigationUrl.request({
        action: '/preencheuCPF ',
      })
    );
    dispatch(updateSession.request());
  }, [dispatch, cpf]);

  useEffect(() => {
    if (status !== '' && status !== 'ok') {
      setLoading(false);
    }
  }, [status]);

  const handleDispatch = () => {
    if (useBirthDate) {
      dispatch(generateToken.failure(''));
      dispatch(validateToken.request(birthDate));
    }
    if (useTwoFactor) {
      setLoading(true);
      dispatch(generateToken.request());
      dispatch(tokenSentTimeAction(moment().toDate()));
    }
    if (useContact && selectedContact) {
      setContactConfirmation(true);
      if (contact !== '') {
        setLoading(true);
        dispatch(generateToken.failure(''));
        dispatch(validateToken.request(contact));
      }
    }
    if (useName) {
      setLoading(true);
      dispatch(generateToken.failure(''));
      dispatch(validateToken.request(name));
    }
    if (useMothersName) {
      setLoading(true);
      dispatch(generateToken.failure(''));
      dispatch(validateToken.request(name));
    }
  };

  if (status === 'ok') {
    return <Redirect to='/validar-token' />;
  }

  return (
    <Wrapper>
      {contactsLoading && (
        <Wrapper>
          <Skeleton className='title' />
          <Skeleton className='subtitle' />
          <Skeleton className='contract' />
          <Buttons>
            <Skeleton className='button' />
            <Skeleton className='button' />
          </Buttons>
          <Skeleton className='info2' />
        </Wrapper>
      )}
      {!contactsByCpf.contactsLoading && useBirthDate && !contactError && (
        <BirthDateValidation
          setBirthDate={setBirthDate}
          birthDate={birthDate}
        />
      )}
      {!contactsLoading && showTwofactor && (
        <TwoFactorValidation
          setLoading={setLoading}
          useTwoFactor={useTwoFactor}
          setInfo={setInfo}
        />
      )}
      {contactConfirmation && (
        <ContactConfirmation
          info={info}
          type={type}
          setContact={setContact}
          contact={contact}
        />
      )}
      {!contactsByCpf.contactsLoading && useName && !contactError && (
        <NameValidation name={name} setName={setName} />
      )}
      {!contactsByCpf.contactsLoading && useMothersName && !contactError && (
        <MothersNameValidation name={name} setName={setName} />
      )}
      {contactError && <ContactError />}

      {!contactsLoading && !contactsByCpf.contactsLoading && (
        <ButtonContainer singleButton={contactError}>
          <Button onClick={handleBack}>VOLTAR</Button>
          {!contactError && (
            <Button color='primary' onClick={handleDispatch} disabled={loading}>
              {loading ? <Loading /> : 'PRÓXIMO'}
            </Button>
          )}
        </ButtonContainer>
      )}
      <Footer>
        {!!contacts.length && !useBirthDate && !useName && (
          <>
            <div>
              <Alert />
            </div>

            <div>
              Se nenhum destes contatos estiver correto, fale conosco através de
              um dos meios listados abaixo.
            </div>
          </>
        )}
      </Footer>
    </Wrapper>
  );
};

export default SelectContact;
